export interface TrendingItem {
  id: number;
  title: string;
  person: string;
  field: string;
  tag: string;
  tagType: 'hot' | 'reverse' | 'verify' | 'filed';
  heat: number;
  heatText: string;
  time: string;
  summary: string;
}

export interface TopicItem {
  id: number;
  name: string;
  en: string;
  count: string;
  desc: string;
}

export interface TimelineStep {
  time: string;
  title: string;
  detail: string;
}

export interface FeaturedStory {
  id: number;
  person: string;
  platform: string;
  follower: string;
  title: string;
  coverAlt: string;
  verdict: string;
  verdictType: 'collapse' | 'verify' | 'reverse';
  intro: string;
  steps: TimelineStep[];
}

export interface EvidenceItem {
  id: number;
  title: string;
  beforeLabel: string;
  afterLabel: string;
  beforeNote: string;
  afterNote: string;
  result: string;
}

export interface PersonArchive {
  id: number;
  alias: string;
  nameEn: string;
  region: string;
  field: string;
  follower: string;
  status: 'collapse' | 'verify' | 'filed';
  statusText: string;
  keyPoint: string;
  keywords: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export const trendingItems: TrendingItem[] = [
  {
    id: 1,
    title: '健身区顶流被扒「体脂造假」全过程逐帧还原',
    person: 'Ryker Venn',
    field: '健身 / Lifestyle',
    tag: '实锤',
    tagType: 'verify',
    heat: 98,
    heatText: '398万',
    time: '25分钟前',
    summary: '前后对比素材被网友逐帧叠加，运动处方与检测报告出现明显时间戳矛盾。',
  },
  {
    id: 2,
    title: '美妆博主翻车实录：素颜护肤人设其实是剪辑滤镜',
    person: 'Mira Sol',
    field: '美妆 / Beauty',
    tag: '发酵中',
    tagType: 'hot',
    heat: 95,
    heatText: '362万',
    time: '48分钟前',
    summary: '同款面霜前后对比被指色温不一致，评论区已开启「逐帧找茬」二创模式。',
  },
  {
    id: 3,
    title: '百万旅行博主「机票抢票」剧情疑似摆拍被石锤',
    person: 'Niko Vega',
    field: '旅行 / Travel',
    tag: '待实锤',
    tagType: 'filed',
    heat: 91,
    heatText: '287万',
    time: '1小时前',
    summary: '后台订票记录截图与视频时间线对不上，官方客服回应成关键证据。',
  },
  {
    id: 4,
    title: '美食吃播网红大胃王「催吐假吃」反向实锤来了',
    person: 'Taro Chen',
    field: '美食 / Food',
    tag: '反转',
    tagType: 'reverse',
    heat: 89,
    heatText: '254万',
    time: '2小时前',
    summary: '上传原素材自证后，评论区出现支持派与扒皮派混战，舆论持续翻转。',
  },
  {
    id: 5,
    title: '英语学习区学霸人设崩了：朗读稿被认出是念稿机',
    person: 'Lyra Moon',
    field: '教育 / Edu',
    tag: '实锤',
    tagType: 'verify',
    heat: 86,
    heatText: '231万',
    time: '3小时前',
    summary: '逐帧对比口型与音轨，网友扒出其所谓「即兴口语」实为提前录制。',
  },
  {
    id: 6,
    title: '健身情侣互撕：广告报价单外流，人设彻底崩塌',
    person: 'Dana & Kato',
    field: '情感 / Couple',
    tag: '发酵中',
    tagType: 'hot',
    heat: 84,
    heatText: '198万',
    time: '4小时前',
    summary: '双人账号解绑公告与报价单先后曝光，粉丝分为两派吵翻天。',
  },
  {
    id: 7,
    title: '穿搭博主「剪标换大牌」风波更新：品牌方正面回应',
    person: 'Sienna Lux',
    field: '时尚 / Fashion',
    tag: '跟进',
    tagType: 'hot',
    heat: 80,
    heatText: '176万',
    time: '5小时前',
    summary: '多个品牌方联合声明，声明细节与此前「全网黑」控评说法存在出入。',
  },
  {
    id: 8,
    title: '音乐区翻唱网红被指音准造假，主播直播回应露馅',
    person: 'Ezra Vox',
    field: '音乐 / Music',
    tag: '发酵中',
    tagType: 'hot',
    heat: 78,
    heatText: '163万',
    time: '6小时前',
    summary: '直播清唱环节与精修版本差异过大，切片视频在多个语言区疯传。',
  },
];

export const topicItems: TopicItem[] = [
  { id: 1, name: '人设崩塌', en: 'Image Collapse', count: '326 篇', desc: '从完美人设到塌房现场，集中整理翻车前后的关键证据链。' },
  { id: 2, name: '数据造假', en: 'Fake Metrics', count: '214 篇', desc: '涨粉造假、刷数据、买量买赞，教你识破成长数据里的水分。' },
  { id: 3, name: '内容摆拍', en: 'Scripted Clips', count: '188 篇', desc: '剧情摆拍、剧本演绎与「真实记录」之间的边界，逐帧拆解。' },
  { id: 4, name: '商业翻车', en: 'Brand Scandals', count: '167 篇', desc: '恰饭翻车、报价外流、品牌割席，广告背后的利益拉扯全记录。' },
  { id: 5, name: '抄袭洗稿', en: 'Plagiarism', count: '143 篇', desc: '搬运、洗稿、二创争议，原创与借鉴的灰色地带逐条对证。' },
  { id: 6, name: '情绪反转', en: 'Plot Twist', count: '121 篇', desc: '先锤后反，真假难辨的舆论翻转现场，记录每一次风向变化。' },
  { id: 7, name: '法律实锤', en: 'Legal Verdict', count: '96 篇', desc: '官司、仲裁、平台封禁等硬核证据，按判决进展持续归档。' },
  { id: 8, name: '亲友爆料', en: 'Insider Leaks', count: '88 篇', desc: '身边人视角的补充信息，与公开素材交叉比对还原真相。' },
];

export const featuredStory: FeaturedStory = {
  id: 1,
  person: 'Ryker Venn',
  platform: 'YouTube · 健身区',
  follower: '1280 万粉丝',
  title: '「体脂造假」事件逐帧还原：从一条举报到全面塌房',
  coverAlt: '健身博主翻车现场事件报道的编辑风格封面图',
  verdict: '已实锤',
  verdictType: 'collapse',
  intro:
    '一条来自前学员的举报帖，在 72 小时内把拥有千万粉丝的健身区顶流拉下神坛。本期我们用逐帧叠加的方式，把体脂造假争议的完整过程按时间线还原，帮你一次看明白来龙去脉。',
  steps: [
    { time: '第 01 天', title: '举报帖引爆', detail: '前学员发布长文，列出训练营前后体脂数据严重不符，附带两段训练视频截图，当晚话题词冲上多语言区趋势榜。' },
    { time: '第 06 小时', title: '原素材流出', detail: '有网友将「对比图」逐帧叠加，发现背景光线与道具位置完全一致，疑似为同一场景不同滤镜拍摄。' },
    { time: '第 02 天', title: '平台介入', detail: '官方检测机构回应称报告格式与公开样例不符，博主团队随后删除多条置顶贴，被质疑「做贼心虚」。' },
    { time: '第 03 天', title: '广告主撤离', detail: '三家长期合作品牌相继宣布暂停合作，报价单外流让商业内幕被进一步放大。' },
    { time: '第 04 天', title: '本人回应', detail: '发布长视频回应，但被网友逐帧指出回应中「数据日期」口误，反而成为新的锤点。' },
    { time: '第 07 天', title: '全面塌房', detail: '账号掉粉超百万，多条历史视频被举报下架，行业媒体发布总结，事件告一段落。' },
  ],
};

export const evidenceItems: EvidenceItem[] = [
  {
    id: 1,
    title: '健身对比图前后：色温与光线被逐帧比对',
    beforeLabel: '「训练前」',
    afterLabel: '「训练后」',
    beforeNote: '网友扒出的原图，画面光线较暗、肤色偏黄。',
    afterNote: '翻红后的对比图，画面明显提亮，同一视角存在滤镜痕迹。',
    result: '光线参数差异过大，被判定为剪辑误导，实锤成立。',
  },
  {
    id: 2,
    title: '素颜 vs 上妆：护肤品宣传是否言过其实',
    beforeLabel: '「素颜前」',
    afterLabel: '「宣传后」',
    beforeNote: '演示片段的初版画面，斑驳感明显。',
    afterNote: '最终投放版本，瑕疵被弱化，肤质看起来更光滑。',
    result: '同源素材二次调色，宣传与演示存在选择性呈现。',
  },
  {
    id: 3,
    title: '订票记录 vs 视频口述：时间线对不上了',
    beforeLabel: '「口述剧情」',
    afterLabel: '「后台记录」',
    beforeNote: '视频中宣称「临时抢到最后一分钟机票」。',
    afterNote: '后台流出记录显示提前多天购票，价格与剧情不符。',
    result: '摆拍证据确凿，已有多位网友整理出完整时间线对照图。',
  },
];

export const personArchive: PersonArchive[] = [
  {
    id: 1,
    alias: 'R.V.',
    nameEn: 'Ryker Venn',
    region: '🇺🇸 美国',
    field: '健身博主',
    follower: '1280万',
    status: 'collapse',
    statusText: '已塌房',
    keyPoint: '体脂数据造假 · 训练营争议',
    keywords: ['数据造假', '广告撤离', '实锤'],
  },
  {
    id: 2,
    alias: 'M.S.',
    nameEn: 'Mira Sol',
    region: '🇬🇧 英国',
    field: '美妆博主',
    follower: '860万',
    status: 'filed',
    statusText: '发酵中',
    keyPoint: '素颜护肤人设疑似滤镜呈现',
    keywords: ['滤镜', '人设', '待实锤'],
  },
  {
    id: 3,
    alias: 'N.V.',
    nameEn: 'Niko Vega',
    region: '🇨🇦 加拿大',
    field: '旅行博主',
    follower: '540万',
    status: 'filed',
    statusText: '待实锤',
    keyPoint: '机票抢票剧情疑似摆拍',
    keywords: ['摆拍', '剧情', '客服回应'],
  },
  {
    id: 4,
    alias: 'T.C.',
    nameEn: 'Taro Chen',
    region: '🇦🇺 澳洲',
    field: '美食吃播',
    follower: '730万',
    status: 'verify',
    statusText: '已反转',
    keyPoint: '催吐假吃指控，本人已自证',
    keywords: ['假吃', '反转', '原素材'],
  },
  {
    id: 5,
    alias: 'E.V.',
    nameEn: 'Ezra Vox',
    region: '🇩🇪 德国',
    field: '音乐翻唱',
    follower: '420万',
    status: 'filed',
    statusText: '发酵中',
    keyPoint: '直播清唱与精修版差异过大',
    keywords: ['直播露馅', '音准', '切片'],
  },
  {
    id: 6,
    alias: 'S.L.',
    nameEn: 'Sienna Lux',
    region: '🇫🇷 法国',
    field: '时尚穿搭',
    follower: '610万',
    status: 'filed',
    statusText: '品牌跟进',
    keyPoint: '剪标换大牌风波，品牌方回应',
    keywords: ['品牌方', '剪标', '跟进'],
  },
];

export const faqItems: FaqItem[] = [
  {
    q: '海外吃瓜到底在「吃」什么？',
    a: '海外吃瓜专注聚合海外网红与博主的黑料与翻车事件。我们帮你把散落在多语言平台的爆料、证据与回应整理成清晰的时间线，让你用最少的时间看清争议全貌。',
  },
  {
    q: '你们的「实锤」「发酵中」是怎么判定的？',
    a: '每个事件都会标注当前证据状态：实锤表示有较充分、可交叉印证的公开证据；发酵中表示讨论热度仍在上升、核心结论尚未定论；待实锤则指证据仍需补充。状态会随进展持续更新。',
  },
  {
    q: '「逐帧还原」具体还原了什么？',
    a: '我们会对翻车现场相关的视频、图片与文字素材做逐帧与时间线层面的比对，例如检查画面光线是否一致、时间戳是否矛盾、口型与音轨是否同步，并把还原过程以图文步骤展示。',
  },
  {
    q: '我看到的素材会不会是断章取义？',
    a: '这正是我们想尽量避免的。单篇内容都会尽量同时呈现支持方与反对方的素材，并标注证据来源与不确定之处。吃瓜需理性，也欢迎你在评论区补充不同视角。',
  },
  {
    q: '如何投稿爆料或补充线索？',
    a: '页面底部设有爆料入口，你可以把线索截图与描述发给我们。为避免误伤，涉及人身的内容我们会先做基础事实核对，再决定是否收录与如何标注。',
  },
  {
    q: '海外吃瓜提供这些内容有什么立场？',
    a: '我们不做裁判，只做素材的搬运工与整理者。立场中立、证据优先，是我们的内容原则。所有人物与事件表述均以公开信息为基准，请以官方与权威渠道信息为准。',
  },
];

export const hotKeywords = [
  '翻车现场',
  '逐帧还原',
  '证据对比',
  '人物档案',
  '人设崩塌',
  '黑料聚合',
];